import React from 'react'

import ScreenContainer from 'components/ScreenContainer'

import ProtectScreenHeader from './ProtectScreenHeader'
import ProtectContent from './ProtectContent'

const Protect = () => (
  <>
    <ProtectScreenHeader />
    <ScreenContainer>
      <ProtectContent />
    </ScreenContainer>
  </>
)

export default Protect
